import Action from '../base/action';

class PlayAudio extends Action {
    audioId;
    _audio;

    constructor(props) {
        super(props);
        this.audioId = props.audioId;
    }

    async execute({training}) {
        const audioData = training.resources[this.audioId].audioData;
        console.log("playing audio:", (audioData ? audioData.name : this.audioId));
        this._audio = training.resources[this.audioId];
        await this._audio.play();
    }

    async stop(training) {
        const audioData = training.resources[this.audioId].audioData;
        console.log("stopping audio:", (audioData ? audioData.name : this.audioId));
        this._audio.stop();
    }
}

export default PlayAudio;
